import React from 'react';
import {NUMVERIFY_API_KEY} from "../../shared/config";
import './ContactForm.css'
import {createUser} from "../../store/actions/user";
import {connect} from "react-redux";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import {sendAnalytics} from "../../store/actions/analytics";
import * as event from '../../shared/analyticEvents';

class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            country: '',
            firstNameError: false,
            lastNameError: false,
            emailError: false,
            phoneError: false,
            marketingConsent: false
        };
    }

    componentDidMount() {
        this.input.focus();
        const subdomainAccountId = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
        this.setState({
            ...this.state,
            accountName: subdomainAccountId
        })
        this.getCountry();
    }

    handleInputChange(e) {
        const {target: {name, value}} = e;
        this.setState({[name]: value});
    }

    static validateName(name) {
        return name.length !== 0;
    }

    static validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    async validatePhone(e, number) {
        e.preventDefault();

        if (!number) {
            this.validateContact();
        }

        const call = await fetch(`https://apilayer.net/api/validate?access_key=${NUMVERIFY_API_KEY}&number=${number}`);
        const res = await call.json();
        if (!res.valid) {
            this.setState({phoneError: true});
        } else {
            this.setState({phoneError: false});
            this.validateContact();
        }
    }

    async getCountry() {
        const call = await fetch("https://ipapi.co/json/");
        const res = await call.json();
        if (res.country) {
            this.setState({country: res.country});
        }
    }

    validateContact() {
        const firstName = ContactForm.validateName(this.state.firstName);
        const lastName = ContactForm.validateName(this.state.lastName);
        const email = ContactForm.validateEmail(this.state.email);

        if (!firstName) {
            this.setState({firstNameError: true});
        } else {
            this.setState({firstNameError: false});
        }

        if (!lastName) {
            this.setState({lastNameError: true});
        } else {
            this.setState({lastNameError: false});
        }

        if (!email) {
            this.setState({emailError: true});
        } else {
            this.setState({emailError: false});
        }

        if (firstName && lastName && email) {
            const utm = localStorage.getItem('utm');
            const utmSource = localStorage.getItem('utm_source');
            const utmMedium = localStorage.getItem('utm_medium');
            const utmCampaign = localStorage.getItem('utm_campaign');
            let hubspotOriginalSource;

            if (utmSource) {
                if (utmSource === "facebook" || utmSource === "Facebook" || utmSource === "linkedin" || utmSource === "LinkedIn") {
                    if (utmMedium && utmMedium === "paid") {
                        hubspotOriginalSource = "PAID_SOCIAL"
                    } else {
                        hubspotOriginalSource = "SOCIAL_MEDIA"
                    }
                } else if (utmSource === "mailchimp" || utmSource === "Mailchimp") {
                    hubspotOriginalSource = "EMAIL_MARKETING"
                } else if (utmSource === "google" || utmSource === "Google") {
                    if (utmMedium && utmMedium === "paid") {
                        hubspotOriginalSource = "PAID_SEARCH"
                    } else {
                        hubspotOriginalSource = "ORGANIC_SEARCH"
                    }
                }
            } else if (!utmSource) {
                hubspotOriginalSource = "ORGANIC_SEARCH"
            }


            let hubspotProperties = [];
            if (hubspotOriginalSource) {
                hubspotProperties.push({
                    propertyName: "hs_analytics_source", propertyValue: hubspotOriginalSource
                })
            }
            if (utmSource) {
                hubspotProperties.push({
                    propertyName: "utm_source__c", propertyValue: utmSource ? utmSource : null
                })
            }
            if (utmMedium) {
                hubspotProperties.push({
                    propertyName: "utm_medium__c", propertyValue: utmMedium ? utmMedium : null
                })
            }
            if (utmCampaign) {
                hubspotProperties.push({
                    propertyName: "utm_campaign__c",
                    propertyValue: utmCampaign ? utmCampaign : null
                })
            }


            let userInfo = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                metadata: {
                    funnel: "NtouchMarketingGiftCrad",
                    source: utm ? utm : null
                },
                hubspotProperties: hubspotProperties,
                marketingConsent: this.state.marketingConsent,
                accountName: this.state.accountName
            };
            if (this.state.phone) {
                userInfo['phone'] = this.state.phone
            }

            console.log("THIS STATE ", this.state)

            this.props.createUser(userInfo);
            this.props.showCreditCardForm();

            localStorage.setItem('email', userInfo.email);
            this.props.sendAnalytics(event.SUBMIT_CONTACT)
        }
    }

    handleOptInChange(e) {

        if (!this.state.marketingConsent) {
            this.setState({marketingConsent: true});
        } else {
            this.setState({marketingConsent: false});
        }
        console.log("e value ", this.state.marketingConsent);

    }

    render() {
        let colorModel;
        let popupButtonColors;
        if (this.props.portalSettings) {
            colorModel = this.props.portalSettings.pageBody.colorModel;

            popupButtonColors = {
                backgroundColor: colorModel.popupButtonBackgroundColor,
                color: colorModel.popupButtonFontColor
            };
        }

        return (
            <React.Fragment>
                <form className={`contactForm ${this.props.className}`}
                      onSubmit={(e) => this.validatePhone(e, this.state.phone)}>
                    <h3 className="contact-form-header">Your Billing Information</h3>
                    <input
                        type="text"
                        name="firstName"
                        placeholder="Enter first name.."
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.firstName}
                        ref={input => this.input = input}
                    /><br/>
                    {this.state.firstNameError ? <p className="error-msg">First name is required..</p> : ''}
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Enter last name.."
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.lastName}
                    /><br/>
                    {this.state.lastNameError ? <p className="error-msg">Last name is required..</p> : ''}
                    <input
                        type="text"
                        name="email"
                        placeholder="Enter email.."
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.email}
                    /><br/>
                    {this.state.emailError ? <p className="error-msg">Valid email is required..</p> : ''}
                    <PhoneInput
                        placeholder="Enter phone number.."
                        onChange={phone => this.setState({phone})}
                        value={this.state.phone}
                        country={this.state.country}
                    /><br/>
                    {this.state.phoneError && this.state.phone ?
                        <p className="error-msg">Valid phone number is required..</p> : ''}

                    <input
                        type="checkbox"
                        name="marketingConsent"
                        onChange={(e) => this.handleOptInChange(e)}
                        value={this.state.marketingConsent}
                    />
                    <label for="marketingConsent"> I want to receive points for my purchase and future discounts and exclusive
                        offers.</label>
                    <button style={popupButtonColors} type="submit" className="contact-submit-btn">Submit</button>
                </form>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.userReducer.loading,
        token: state.userReducer.token,
        error: state.userReducer.error,
        portalSettings: state.portalSettingsReducer.portalSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createUser: (userInfo) => dispatch(createUser(userInfo)),
        sendAnalytics: (eventTag) => dispatch(sendAnalytics(eventTag))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
